export default __webpack_public_path__ + "static/media/ic_check.7c2fde70.svg";